import { Box, Typography } from "@mui/material";

function CardBottomText({
  startIcon,
  suffix,
  value,
  prefix,
  color = "secondary",
}: {
  startIcon: React.ReactNode;
  suffix: string;
  value: string;
  prefix?: string;
  color?: "primary" | "secondary" | "tertiary" | "text.primary" | "text.secondary" | "inherit";
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "baseline",
        justifyContent: "flex-start",
        color: color,
      }}
    >
      {startIcon}
      <Typography component="span" variant="labelLarge" color={color} style={{ marginLeft: 8 }}>
        {prefix} {value} {suffix}
      </Typography>
    </Box>
  );
}

export default CardBottomText;
